import { Module } from 'vuex';
import { IDocument } from '@/types/Document';
import { RootState } from '@/store/store';
import { actions } from '@/dealroom-view/store/dealroom-view.actions';
import { mutations } from '@/dealroom-view/store/dealroom-view.mutations';
import { IField } from '@/fields/types/field';
import { getters } from '@/dealroom-view/store/dealroom-view.getters';

export const namespace: string = 'dealroomView';

export interface IDealroomViewState {
  loading: boolean;
  loaded: boolean;
  document: IDocument;
  fields: IField[];
  pageWidth: number;
}

export const state: IDealroomViewState = {
  loading: false,
  loaded: false,
  document: null,
  fields: [],
  pageWidth: 0,
};

export const dealroomView: Module<IDealroomViewState, RootState> = {
  state,
  actions,
  mutations,
  getters,
  namespaced: true,
};
